const validateUser = (payload: string, userEmails: string[]): boolean => {
  return userEmails.some((userEmail) => {
    return payload.includes(userEmail);
  });
};

export { validateUser };
